<script setup lang="ts">
import { VIcon } from '@/modules/shared/components'

defineProps<{
  title?: string
  description?: string
}>()
</script>

<template>
  <div class="mx-auto flex w-fit flex-col items-center">
    <VIcon name="Loading" class="h-10 w-10 animate-spin-fast" />
    <div class="mt-10 text-center text-xl font-bold" v-if="title">{{ title }}</div>
    <div class="mt-3 max-w-[500px] text-center text-sm text-gray-500" v-if="description">
      {{ description }}
    </div>
  </div>
</template>
